import React, { useEffect, useState } from "react";
import { Link, graphql } from "gatsby";
import DecorationBlob19 from "../images/decorations/deco-blob-19.svg";
import Layout from "../components/layout";
import CardBlog from "../components/CardBlog";
import SocialShare from "../components/SocialShare";
import SocialShareSmall from "../components/SocialShareSmall";
import ViewCounter from "../components/ViewCounter";
import NewsletterFormHorizontal from "../components/NewsletterFormHorizontal";
import useScriptForm from "../hooks/useScript";
import { FaqJson } from "../components/Faq";
import StructuredTextRenderer, {
  StructuredModuleTypes
} from "../components/StructuredTextRenderer";
import SocialShareFloating from "../components/SocialShareFloating";
import { ArticleJsonLd } from "../components/jsonld/ArticleJsonLd";
import {GatsbyImage} from "gatsby-plugin-image";

const ArticleTemplate = ({ data, location: { pathname } }) => {
  const ArticleData = data.datoCmsArticle;

  const ArticlesData = data.allDatoCmsArticle.edges;

  const ArticleMetaData = {
    author: ArticleData.author.fullName,
    category: ArticleData.category.name,
    canonicalLink: ArticleData.canonicalLink
  };

  const [elemCtaOffsetTop, setElemCtaOffsetTop] = useState(0);
  // const [elemStickyOffsetTop, setElemStickyOffsetTop] = useState(0);

  useEffect(() => {
    document.addEventListener("scroll", scrollHandler);

    return () => {
      document.removeEventListener("scroll", scrollHandler);
    };
  });

  const scrollHandler = () => {
    const elemCta = document.querySelector(".article-cta");
    // const elemSticky = document.querySelector(".sticky-top");
    elemCta ? setElemCtaOffsetTop(elemCta.offsetTop) : setElemCtaOffsetTop(0);
    // elemSticky ? setElemStickyOffsetTop(elemSticky.offsetTop) : setElemStickyOffsetTop(0);
    // console.log(elemCtaOffsetTop);
  };

  const faqs = ArticleData.contentStructuredText.blocks
    .filter(b => b.__typename === StructuredModuleTypes.DatoCmsFaqItem)
    .map(({ answer, question }) => ({
      answer,
      question
    }));

  return (
    <>
      <FaqJson faqs={faqs} />

      <ArticleJsonLd article={ArticleData} />

      <Layout
        footerBgClass="bg-white"
        meta={{
          seo: {
            ...ArticleData.seo,
            title: !ArticleData.seo.title || ArticleData.seo.title == '' ? ArticleData.title : ArticleData.seo.title,
            description: !ArticleData.seo.description || ArticleData.seo.description == '' ? ArticleData.cardDescription: ArticleData.seo.description,
            image: ArticleData.seo.image ? ArticleData.seo.image : { url: ArticleData.cardImage.url }
          },
          articleSeo: ArticleMetaData,
          path: pathname
        }}
      >
        <div className="article-template-page">
          <section className="pb-0">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb align-items-center">
                        <li className="breadcrumb-item">
                          <Link to="/blog">Blog</Link>
                        </li>
                        <li className="breadcrumb-item align-items-center">
                          {ArticleData.category.name}
                        </li>
                      </ol>
                    </nav>
                    <span className="badge bg-primary-alt">
                      <ViewCounter id={ArticleData.slug} />
                      views
                    </span>
                  </div>

                  <div className="d-block d-lg-none d-flex align-items-center py-2">
                    <GatsbyImage imgClassName="avatar"  className="avatar mr-1" image={ArticleData.author.avatar.gatsbyImageData} alt={ArticleData.author.fullName} loading="eager" />

                    <div>
                      <div className="">
                        by {ArticleData.author.fullName},{" "}
                        {ArticleData.author.role}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="p-0">
            <div className="container">
              <div className="row justify-content-left position-relative">
                <div className="col-md-7" />
              </div>
              <div className="row">
                {/* <div className="col-xl-1 col-lg-1 d-lg-block d-none">

                <div className="sticky-top"
                    style={{ top: 100, marginTop: 200, marginLeft: '-100px' }}
                    data-aos="fade-in" data-aos-delay="400"
                >

                  <SocialShareFlex link={pathname} />
                </div>
              </div> */}

                <div className="col-xl-8 col-lg-8 col-md-12">
                  <h1 className="display-4">{ArticleData.title}</h1>

                  <div className="rounded mb-4 overflow-hidden">
                    <GatsbyImage image={ArticleData.cardImage.gatsbyImageData}
                                 alt={ArticleData.title} loading="eager" />
                  </div>

                  <article
                    id="article-content"
                    className="article article-blog"
                  >
                    <StructuredTextRenderer
                      data={ArticleData.contentStructuredText}
                    />
                  </article>
                </div>

                <div
                  className="d-none d-lg-block col-xl-3 col-lg-4 col-3 ml-auto"
                  style={{
                    maxHeight: elemCtaOffsetTop > 1023 ? elemCtaOffsetTop: '100%',
                    alignSelf: 'auto'
                  }}
                >
                  <div className="card card-sm card-body card--no-hover bg-white mb-6">
                    <div className="my-auto text-center">
                      <GatsbyImage className="avatar mr-2 mb-2"
                                   image={ArticleData.author.avatar.gatsbyImageData}
                                   alt={ArticleData.author.fullName} loading="eager" />

                      <p className="">
                        <strong>
                          {ArticleData.author.fullName}
                          {ArticleData.author.fullName == "Adam Fard"
                            ? " . Founder"
                            : " . " + ArticleData.author.role}
                        </strong>
                      </p>
                      <p>
                        Helping startups to improve their app’s usability &
                        realize their business goals
                      </p>

                      <Link to="/about-us" className="hover-arrow">
                        Learn more
                      </Link>
                    </div>
                  </div>

                  <div className="card card-sm card-body card--no-hover bg-primary-3 text-light mb-6">
                    <div className="my-auto text-left">
                      <div id="activecampaign-form" className="form-small">
                        <div id="activecampaign-form__wrapper">
                          <h4 className="h4 text-center mb-2">
                            Exclusive Articles & Strategies
                          </h4>
                          <p className="text-center mb-2">
                            for Startups, UX Designers & Entrepreneurs
                          </p>
                          {/*<img src={NewsletterImage1} class="newsletter_image" alt="" />*/}
                          <div id="activecampaign-form">
                            <div id="activecampaign-form__wrapper">
                              <div className=" _form_7"></div>
                            </div>
                          </div>
                          {useScriptForm(
                            "https://adamfard48700.activehosted.com/f/embed.php?id=7"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <SocialShare link={pathname} className="mb-4" />

                  {/* <div className="" >
                    <div className="my-auto text-left">
                      <p className="lead"><strong>Popular Stories:</strong></p>
                      <a href="https://adamfard.com/about-us" className="h4 hover-arrow">
                        Learn more
                      </a>
                    </div>
                  </div> */}

                  <div
                    className="sticky-top card-sm card card-body card--no-hover bg-primary-alt"
                    style={{
                      top: "calc(50vh - 175px)",
                      marginBottom: 200,
                      marginTop: 700
                    }}
                    data-aos="fade-left"
                    data-aos-delay="300"
                  >
                    <div className="text-center">
                      <h4 className="h4 mb-2">{ArticleData.ctaTitle}</h4>
                      <p className="">{ArticleData.ctaContent}</p>
                      <Link
                        to="/contact-us"
                        id="blog-c-freeconsultation"
                        className="btn btn-primary mt-2"
                        target="_blank"
                      >
                        {!ArticleData.ctaLabel || ArticleData.ctaLabel == '' ? 'Contact Us' : ArticleData.ctaLabel}
                      </Link>
                      {/* <small className="mt-2">Apply for a 30min Session</small> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container pt-0">
              <div className="row justify-content-left">
                <div className="col-xl-8 col-lg-8 col-md-10">
                  <hr />
                  <SocialShare link={pathname} title={ArticleData.title} />
                </div>
              </div>
            </div>
          </section>

          <section className="related-stories o-hidden has-divider mt-4">
            {/*<div className="divider">
          <Divider1 style={{ transform: 'matrix(-1, 0, 0, -1, 0, 0)' }} />
        </div>*/}

            <div className="decoration-wrapper">
              <div
                className="decoration deco-blog-bg"
                style={{ top: -370, overflowX: "hidden", width: "100%" }}
              >
                <DecorationBlob19
                  className="bg-primary-alt flip-x"
                  style={{ width: "100%" }}
                />
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col">
                  <h3 className="h1">Related Stories</h3>
                </div>
              </div>
              <div className="row">
                {ArticlesData.map(({ node }) => (
                  <div className="col-md-6 col-lg-4" key={node.id}>
                    <CardBlog cardData={node} />
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* <DisqusBlock url={pathname} identifier={ArticleData.id} title={ArticleData.title} /> */}

          <NewsletterFormHorizontal />
        </div>

        {/* <Helmet defer={false}>
        {typeof window !== "undefined" && (
          <script async>
            {(function(s, u, m, o, j, v) {
              j = u.createElement(m);
              v = u.getElementsByTagName(m)[0];
              j.async = 1;
              j.src = o;
              j.dataset.sumoSiteId =
                "16e244d058dd76962667e7c26703874e4f8521570f54dd408cf6836b97a0c3b3";
              v.parentNode.insertBefore(j, v);
            })(window, document, "script", "//load.sumo.com/")}
          </script>
        )}
          </Helmet>*/}

        {/*<Helmet>*/}
        {/*  {typeof window !== "undefined" && (*/}
        {/*    <script*/}
        {/*      async*/}
        {/*      src="s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5c42084101837020"*/}
        {/*    />*/}
        {/*  )}*/}
        {/*</Helmet>*/}
      </Layout>

      <SocialShareFloating id={ArticleData.slug} link={pathname} />
    </>
  );
};

export default ArticleTemplate;

export const query = graphql`
  query ArticleTemplate($id: String!) {
    datoCmsArticle(id: { eq: $id }) {
      id
      title
      cardDescription
      keywords
      category {
        name
      }
      date
      author {
        fullName
        role
        avatar {
          gatsbyImageData(width: 150,  layout: CONSTRAINED)
        }
      }
      cardImage {
        url
        gatsbyImageData(width: 1600,  layout: CONSTRAINED)
      }
      contentStructuredText {
        value
        blocks {
          __typename
          ... on DatoCmsFaqItem {
            id: originalId
            answer
            question
          }
          ... on DatoCmsImageBlock {
            id: originalId
            caption
            noVerticalMargin
            edgeToEdge
            image {
              customData
              url
              alt
              format
              mimeType
              url
              video {
                mp4Url
              }
              gatsbyImageData(width: 800,  layout: CONSTRAINED)
            }
          }
          ... on DatoCmsCtaBlock {
            id: originalId
            badge
            buttonText
            title
            ctaContent
            buttonLink
            image {
              customData
              alt
              title
              gatsbyImageData(width: 800,  layout: CONSTRAINED)
            }
          }
          ... on DatoCmsScrolltocta {
            id: originalId
            content
          }
          ... on DatoCmsHtmlBlock {
            id: originalId
            htmlField
            htmlCaption
          }
        }
      }
      slug
      seo {
        title
        description
        twitterCard
        image {
          url
        }
      }
      canonicalLink
      ctaTitle
      ctaContent
      ctaLabel
    }

    allDatoCmsArticle(
      limit: 3
      filter: { id: { ne: $id } }
      sort: { fields: date, order: DESC }
    ) {
      edges {
        node {
          title
          cardDescription
          cardImage {
            gatsbyImageData(width: 355,  layout: CONSTRAINED)
          }
          category {
            name
          }
          id
          slug
        }
      }
    }
  }
`;
